import { Stack, styled } from '@cyberlab/uikit';

const Wrapper = styled(Stack)(({ theme: { spacing, palette } }) => ({
  padding: spacing(2),
  backgroundColor: palette.bg?.paper,
}));

export default Wrapper;
